export default __webpack_public_path__ + "media/svgs/settings-0bf2003f.svg";